<template>
  <div>
    <BaseSpinner v-if="showSpinner" />
    <b-row align-v="center" class="pt-2">
      <b-col md="auto">
        <div>
          <BaseELabel
            label="Business Information"
            :class="$style.labelSubHeading"
          />
        </div>
      </b-col>
      <b-col class="border-bottom"></b-col>
    </b-row>
    <b-row>
      <b-col md="3">
        <BaseEInputText
          id="businessName"
          v-model="businessName"
          v-validate="{ required: true }"
          data-vv-as="Business Name"
          type="text"
          name="businessName"
          maxlength="100"
          mark-required
          label-content="Name"
          :placeholder="placeholders.businessName"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('businessName') }} </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="phoneNumber"
          v-model="phoneNumber"
          v-validate="{
            required: false,
            regex: /^\(\d{3}\)\s*\d{3}(?:-|\s*)\d{4}$/,
          }"
          validattor="[0-9]"
          maskker="(\d{3})(\d{3})(\d{4})"
          formatter="($1) $2-$3"
          type="text"
          maxlength="14"
          name="phoneNumber"
          label-content="Phone Number"
          data-vv-as="Phone #"
          :placeholder="placeholders.phoneNumber"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('phoneNumber') }}
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="5">
        <BaseEInputText
          id="streetAddress"
          v-model="streetAddress"
          type="text"
          name="streetAddress"
          maxlength="100"
          data-vv-as="Street"
          label-content="Street"
          :placeholder="placeholders.streetAddress"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('streetAddress') }} </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="cityName"
          v-model="cityName"
          v-validate="{ required: false, regex: /^[A-Za-z -.]+$/ }"
          validattor="^[A-Za-z -.]+$"
          type="text"
          name="cityName"
          maxlength="20"
          label-content="City"
          data-vv-as="City Name"
          :placeholder="placeholders.cityName"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('cityName') }}
        </div>
      </b-col>
      <b-col md="2">
        <BaseELabel mark-required label="State" />
        <BaseDropdown
          v-model="state"
          v-validate="'required'"
          :field-id="state"
          :options="states"
          name="state"
          :placeholder="placeholders.state"
          :class="$style.dropOptionstyle"
        ></BaseDropdown>
        <div v-show="errors.has('state')" class="error">
          State is required
        </div>
      </b-col>
    </b-row>
    <b-row>
     <b-col md="3">
       <BaseEInputText
         id="taxID"
         v-model="taxID"
         v-validate="{
           required: false,
         }"
         validattor="^[0-9]+$"
         data-vv-as="Tax ID"
         type="text"
         name="taxID"
         maxlength="9"
         label-content="Tax ID"
         :placeholder="placeholders.taxID"
         aria-describedby="taxID-live-feedback"
       ></BaseEInputText>
       <div class="error">
         {{ errors.first('taxID') }}
       </div>
     </b-col>
     <b-col md="6"> </b-col>
   </b-row>
    <b-row class="pb-3 border-bottom">
      <b-col class="col-9">
        <BaseTextarea
          id="comments"
          v-model="comments"
          v-validate="{ required: false }"
          maxlength="30"
          name="comments"
          label-content="Comments"
        ></BaseTextarea>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6">
        <BaseELabel label="Report Format" />
        <b-form-group>
          <b-form-radio-group
            :key="typeOption.id"
            v-model="reportType"
            :options="typeOption"
            class="mr-5"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col md="2">
        <BaseEButton @click="onSearch">
          Search
        </BaseEButton>
      </b-col>
    </b-row>
  </div>
</template>
<style lang="scss" module>
@import '@design';
.dropOptionstyle option {
  font-size: 16px;
}
.labelSubHeading {
  margin-left: -2rem;
  font-size: $size-content-font;
  font-weight: 500;
  color: $color-text-gray;
}
</style>
<script>
import {
  equifaxPaynetReportMethods,
  toasterMethods,
} from '@state/helpers'
import constant from '@constants/constant'
export default {
  props: {
    customerId: {
      type: Number,
      default: 0,
    },
    customerUserId: {
      type: Number,
      default: 0,
    },
    productId: {
      type: String,
      default: '',
    },
    searchData: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      streetAddress: '',
      cityName: '',
      state: '',
      comments: '',
      errorLog: '',
      showSpinner: false,
      taxID: null,
      businessName: '',
      stateCode: '',
      phoneNumber: '',
      requestData: '',
      currentUserId: '',
      typeOption: [
        { text: 'PDF', value: 'PDF' },
        { text: 'HTML', value: 'HTML' },
      ],
      reportType: constant.reportDataType.PDF,
    }
  },
  computed: {
    placeholders() {
      return {
        businessName: 'Business Name',
        cityName: 'City Name',
        state: 'Select State',
        streetAddress: 'Street Address',
        phoneNumber: '(xxx) xxx-xxxx',
        taxID: 'xxxxxxxxx',
      }
    },
    states() {
      return this.$_allStates
    },
    SEARCH_DATA(){
      return this.searchData || null
    },
  },
  mounted() {
    if (this.SEARCH_DATA) {
      this.loadRefineSearch()
    }
  },

  methods: {
    ...equifaxPaynetReportMethods,
    ...toasterMethods,
    buildEQPaynetReportJSON() {
      return JSON.stringify({
        userId: this.currentUserId,
        orderForCustomer: this.customerId,
        orderForUser: this.customerUserId,
        productId: this.productId,
        companySearch: {
        company_name: this.businessName,
        address: this.streetAddress,
        city: this.cityName,
        state_code: this.getStateCode(this.state),
        stateId: this.state,
        phone: this.phoneNumber,
        tax_id: this.taxID,
        user_field: this.comments,
        reportType: this.reportType,
        }
      })
    },
    onSearch(selectedValue) {
      let userInfo = this.$store.state.auth.currentUser.userInfo
      var isOrderReportComponentValid = false
      var isEQPaynetReportComponentValid = false
      this.currentUserId = userInfo.userId
      this.$parent.$parent.$validator.validateAll().then((response) => {
        isOrderReportComponentValid = response
        this.$validator.validate().then((response) => {
          isEQPaynetReportComponentValid = response
          if (isOrderReportComponentValid && isEQPaynetReportComponentValid) {
            this.showSpinner = true
            this.requestData = this.buildEQPaynetReportJSON()
            this.fetchEQPaynetSearchReport({
                eqPaynetReportData: this.requestData,
              })
              .then((response) => {
                if(response.status === 200) {
                    this.$router.push({
                    name: 'paynetSearchResults',
                    params: {
                      searchResponse: response.data,
                      searchRequest: this.requestData,
                      searchFor: this.businessName,
                    },
                    })
                }
              })
              .catch((error) => {
                this.setAlert({
                  title: constant.imageHeaderError,
                  msg: constant.errorMessage,
                  variant: constant.errorMessagetype,
                })
                this.errorLog = error
              }).finally(() => { this.showSpinner = false })
          }
        })
      })
    },
    loadRefineSearch() {
      if(this.SEARCH_DATA !== null) {
        this.showSpinner = true
        let orderData = JSON.parse(this.searchData)
        let searchReqObj = orderData.companySearch
        this.businessName = searchReqObj.company_name
        this.phoneNumber = searchReqObj.phone
        this.streetAddress = searchReqObj.address
        this.cityName = searchReqObj.city
        this.state = searchReqObj.stateId
        this.taxID = searchReqObj.tax_id
        this.comments = searchReqObj.user_field
        this.reportType = searchReqObj.reportType
        this.showSpinner = false
      }
    },
    getStateCode(stateValue) {
      if (stateValue !== '') {
        var stateCode = this.states.find(
          (x) => x.value === Number(stateValue)
        ).stateCode
      }
      return stateCode
    },
  },
}
</script>
